import Swiper from "swiper";
// REMOVED: Navigation from the import
import { Pagination, Autoplay, EffectFade } from "swiper/modules";

// Import Swiper styles needed
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

function initHeroCarousel() {
  const heroCarouselElement = document.querySelector(".hero-carousel");

  if (!heroCarouselElement) {
    return;
  }

  // Initialize Swiper
  const swiper = new Swiper(heroCarouselElement, {
    // REMOVED: Navigation from the modules array
    modules: [Pagination, Autoplay, EffectFade],

    // Configuration
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },

    // Autoplay
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    // Pagination
    pagination: {
      el: ".hero-carousel-pagination",
      clickable: true,
    },

    // REMOVED: The entire navigation object
  });
}

// Run the initialization
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  initHeroCarousel();
} else {
  document.addEventListener("DOMContentLoaded", initHeroCarousel);
}
